import React from 'react';
import { Col, Modal, OverlayTrigger, Pagination, Row, Tooltip } from 'react-bootstrap';
import './Subscription.scss';
import '../../../common/components/pagination/Pagination.scss'
import { Text } from '../../../common/components/text/Text'
import { Space } from '../../../common/components/space/Space';
import { Main } from '../../../common/components/main/Main';
import { Button } from '../../../common/components/button/Button';
import Card from '../../../common/components/card/Card';
import { Table } from '../../../common/components/table/Table';
import Icons from '../../../common/components/icon/Icon';
import { format, parseISO } from 'date-fns'
import { subscriptionListGetAction, subscriptionSetSelectedAction } from "../../../store/action/subscriptionAction";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { history } from '../../../store';
import { Flex } from '../../../common/components/flex/Flex';
import subscriptionService from '../../../services/subscriptionService'
import swal from 'sweetalert';
import { ReactNode } from 'react'
import Loader from 'react-loader-spinner';
//import { InputWithIcon } from '../../../common/components/control/Control';
import NumberFormat from 'react-number-format'
import coin from '../../../../assets/images/coin.jpg';

const SubscriptionList = (props: any) => {
  const { subscription, isLoading, totalElement, totalPage } = props
  const [display, setDisplay] = React.useState<any>([])
  const [page, setPage] = React.useState(0)
  const [pagination, setPagination] = React.useState([{}])
  const [searchInput, setSearchInput] = React.useState('')
  const [low, setLow] = React.useState(1)
  const [high, setHigh] = React.useState(9)
  const perPage = 9
  const [showDelete, setShow] = React.useState(false);
  const [deleteSubs, setDeleteSubs] = React.useState(0)

  // Used to get type and payload, call action and get list.   
  React.useEffect(() => {
    props.subscriptionListGetAction({ size: 10, page })
  }, [page])

  // Check ships(list) length, add checked false in that array.  
  React.useEffect(() => {
    // console.log(subscription, 'ship type in ship type lisst page')
    if (subscription && subscription.length > 0) {
      setDisplay(() => {
        return subscription.map((s: any) => ({ ...s, checked: false }))
      })
    }
    if (subscription && subscription.length === 0) {
      setDisplay([])
    }
  }, [subscription])

  // Get totalPage in props and push into the pagination variable.   
  React.useEffect(() => {
    const arrayPage = Array.from(Array(props.totalPage).keys())
    setPagination(arrayPage)
  }, [props.totalPage])

  //Seaarch Function

  // const _searchFuntion = (value:string) => {
  //   setSearchInput(value)
  //   props.dockListGetAction({ size: 10, page:0, companyName: value })
  // }

  // Redirect to ship detail page.  
  const _willViewDetail = (subscription: any) => {
    subscriptionSetSelectedAction(subscription)
    history.push(`/subscription/${subscription.id}`)
  }

  // Redirect to ship edit page.  
  const _willViewEdit = (subscription: any) => {
    props.subscriptionSetSelectedAction(subscription)
    history.push(`/subscription/edit/${subscription.id}`)
  }

  // Delete the pericular list.
  const handleClose = () => setShow(false);
  const handleShow = (subscription: any) => {
    setShow(true);
    setDeleteSubs(subscription.id)
    // console.log(deleteAnode, 'deleted anode id')
  }

  const _willDelete = () => {
    // console.log(deleteAnode, 'deleted anode id')
    _deleteSubscription(deleteSubs)
  }


  const _deleteSubscription = (id: any) => {
    return subscriptionService.deleteSubscription(id).subscribe({
      next: (r) => {
        // console.log(r,'response')
        setShow(false)
        swal("Great", " Deleted Successfully", "success")
        props.subscriptionListGetAction({ size: 10, page })
      },
      error: err => {
        swal("OOPS", String(err), "error")
      }
    })
  }

  const _showAll = () => {
    setSearchInput('')
    props.subscriptionListGetAction({ size: 10, page })

  }

  const _searchFuntion = (value: string) => {
    setSearchInput(value)
    props.subscriptionListGetAction({ size: 10, page })
    setPage(0)
  }

  // Prints first page pagination.  
  const firstPage = () => {
    if (page >= 1) {
      return <Pagination.First onClick={() => _goToFirstPage()}>First</Pagination.First>
    }
  }

  // While click the last page its move to last page.  
  const _goToLastPage = () => {
    setPage(totalPage - 1)
    setHigh(totalPage - 1)
    setLow(totalPage - 9)
  }

  // While click the first button its move to first page.  
  const _goToFirstPage = () => {
    setPage(0)
    setHigh(9)
    setLow(1)
  }

  // Prints last page pagination button.  
  const lastPage = () => {
    if (page !== totalPage - 1) {
      if (page <= high) {
        return <Pagination.Last onClick={() => _goToLastPage()}>Last</Pagination.Last>
      }
    }
  }

  // Prints prev button.  
  const prevBtn = () => {
    if (page >= 1) {
      if (page + 1 === low) {
        setHigh(high - perPage)
        setLow(low - perPage)
      }
      return <Pagination.Prev onClick={() => _goPrevPage()}>Prev</Pagination.Prev>
    }
  }

  // While click prev button go to the previous page of current page.  
  const _goPrevPage = () => {
    setPage(prev => {
      const newValue = prev - 1
      return newValue
    })
  }

  // Print next button.  
  const nextBtn = () => {
    if (page < totalPage - 1) {
      if (page <= high) {
        return <Pagination.Prev onClick={() => _goNextPage()}>Next</Pagination.Prev>
      }
      else {
        setHigh(high + perPage)
        setLow(low + perPage)
      }
    }
  }

  // While click next page button go to the next page of the current page.  
  const _goNextPage = () => {
    setPage(prev => {
      const newValue = prev + 1
      return newValue
    })
  }

  // While click one page number its move to that page.  
  const _goToPage = (page: any) => {
    setPage(page)
  }

  // Return the page number
  const ListItem = (page: any) => {
    return page.value + 1
  }

  // Prints the totalpages between prev, next button.  
  const PageNumber = pagination.map((p, i) => {
    var pagination_num: ReactNode;
    if ((p === 0 && page === 0)) {
      pagination_num = <Pagination.Item onClick={() => _goToPage(p)} active={p === page} key={i}><ListItem value={p} /></Pagination.Item>
    }
    else if ((p < high + 1) && (p >= low - 1)) {
      pagination_num = <Pagination.Item onClick={() => _goToPage(p)} active={p === page} key={i}><ListItem value={p} /></Pagination.Item>
    }
    return (
      pagination_num
    )
  })

  return (
    <Main>
      <Text variant="title" color='black'>Subscription Plan List</Text>
      <Space divheight={15} />
      <Card>
        <SearchForm>
          <Row className='m-0 p-0'>
            <Col xs='12' sm='12' md='12' lg='4' xl='4' className='m-0 p-0'>
              <div className='mr-2 mb-2 mb-sm-2 mb-md-2 mb-lg-0 mb-xl-0'>
                <Row className='m-0 p-0'>
                  <Col xs='12' sm='10' md='9' lg='12' xl='12' className='m-0 p-0'>
                    <Link to='/subscription/add'>
                      <Button variant='transparent' block={true}>
                        <Icons color="#ffffff" icon="add" />
                        ADD NEW PLAN
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </SearchForm>
        {/* <SearchForm>
          <Row className='m-0 p-0'>
            <Col xs='12' sm='12' md='12' lg='4' xl='4' className='m-0 p-0'>
              <div className='mr-2 mb-2 mb-sm-2 mb-md-2 mb-lg-0 mb-xl-0'>
                <Row className='m-0 p-0'>
                  <Col xs='12' sm='10' md='9' lg='12' xl='12' className='m-0 p-0'>
                    <InputWithIcon
                      type="text"
                      value={searchInput}
                      onChange={(e) => _searchFuntion(e.target.value)}
                      placeholder="Search by Plan Name.."
                      icon="search"
                      id="search-inputplan"
                    />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs='12' sm='12' md='12' lg='7' xl='7' className='m-0 p-0'>
              <Row className='m-0 p-0'>
                <Col xs='6' sm='4' md='4' lg='3' xl='3' className='m-0 p-0 mr-2'>
                  <Link to='/subscription/add'>
                    <Button variant='transparent' block={true}>
                      <Icons color="#ffffff" icon="add" />
                      ADD NEW PLAN
                    </Button>
                  </Link>
                </Col>
                <Col xs='5' sm='4' md='4' lg='3' xl='3' className='m-0 p-0 '>
                  <div>
                    <Button variant='transparent' block={true} onClick={() => _showAll()}>
                      Show All
                    </Button>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </SearchForm> */}
        <Space divheight={30} />
        {isLoading && <Text center>
          <Loader
            type="Rings"
            color="#233269"
            height={100}
            width={100}
            timeout={30000}
          />
        </Text>} {/* Check the list is loading, isloading is true its shows loading text.  */}
        {!isLoading && display.length === 0 && (
          <>
            <Space divheight={20} />
            <Text center>No Subscription Plan Found</Text>
            <Space divheight={20} />
          </>
        )} {/* If isloading is false and also the list array length is 0 its shows no discount fount text.   */}
        {!isLoading && display.length > 0 && (
          <>
            <Table>
              <thead>
                <tr key={0}>
                  <th>S.No</th>
                  <th>Created date</th>
                  <th>Subscription Plan Name</th>
                  <th>Price (Coins)</th>
                  <th className='text-lg-center'>Duration in Day(s)</th>
                  <th>System Access</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {display.map((data: any, i: any) => (
                  <tr key={i}>
                    <td data-label='S.No'>
                      {page === 0 && (
                        i + 1
                      )}
                      {page >= 1 && (
                        (page * 10) + (i + 1)
                      )}
                    </td>
                    <td data-label='Created Date'>
                      {data.created_at === null || '' ? (
                        <Text variant='caption' color='tabledata'>null</Text>
                      ) : (
                        <Text variant='caption' color='tabledata'>{format(parseISO(data.createdAt), 'dd/MM/yyyy')}</Text>
                      )}
                    </td>
                    <td data-label='Subscription Plan Name'>{data.name}</td>
                    <td data-label='Amount'>
                      {data.price === null ? (
                        <Text variant='caption' color='tabledata'>-</Text>
                      ):(
                        <Text className='txt-table-date' color='tabledata'>
                              <NumberFormat value={String(data.price)} displayType={'text'} thousandSeparator={true}/>
                            </Text>
                        // <>
                        //  {!String(data.price).includes('.') && (
                            
                        //   )}
                        //   {String(data.price).includes('.') && (
                        //     <Text className='txt-table-date' color='tabledata'>
                        //       <NumberFormat value={data.price} displayType={'text'} thousandSeparator={true} prefix={'Rp. '} />
                        //     </Text>
                        //   )
                        //   }
                        // </>
                      )}
                    </td>
                    <td data-label='Duration in Day(s)' className='text-lg-center'>
                      {data.durationInMonth === null || '' ? (
                        <Text variant='caption' color='tabledata'>-</Text>
                      ) : (
                        <Text variant='caption' color='tabledata'>{data.durationInMonth}</Text>
                      )}
                    </td>
                    <td data-label='Status'>
                      {data.isactive === false || '' ? (
                        <Text color='danger' variant='subtitle'>Inactive</Text>
                      ) : (
                        <Text color='success' variant='subtitle'>Active</Text>
                      )}
                    </td>
                    <td>
                      <TableActions>
                        <OverlayTrigger overlay={
                          <Tooltip id="subscription-view"> View
                          </Tooltip>
                        }>
                          <Button className='link_button' onClick={() => _willViewDetail(data)}>
                            <Icons color="#52575a" icon="visibility" />
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={
                          <Tooltip id="subscription-edit"> Edit
                          </Tooltip>
                        }>
                          <Button className='link_button' onClick={() => _willViewEdit(data)}> {/* While onclick open edit page.   */}
                            <Icons color="#52575a" icon="edit" /> {/* Edit icon.  */}
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={
                          <Tooltip id="subscription-delete"> Delete
                          </Tooltip>
                        }>
                          <Button className='link_button' onClick={() => handleShow(data)}>
                            <Icons color="#52575a" icon="delete" />
                          </Button>
                        </OverlayTrigger>
                      </TableActions>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <TableFooter>
              {/* {console.log(totalElement, 'total element')} */}
              <Text> {/* Display the total elements.  */}
                {display.length === 1 && (
                  <>
                    <b>
                      {display.length}
                      {/* {((page)*10)+1} - {(display.length+(page)*10)} */}
                    </b> of {totalElement} subscription plan
                  </>
                )}
                {display.length > 1 && (
                  <>
                    <b>
                      {display.length}
                      {/* {((page)*10)+1} - {(display.length+(page)*10)} */}
                    </b> of {totalElement} subscription Plans
                  </>
                )}
              </Text>
              <Pagination size="sm">
                {firstPage()} {/* First page button.   */}
                {prevBtn()} {/* Previous button.   */}
                {PageNumber} {/* Totalpages.   */}
                {nextBtn()} {/* Next button.   */}
                {lastPage()} {/* Last page button.   */}
              </Pagination>
            </TableFooter>
          </>
        )}
      </Card>
      {/* If modal is true goto the delete box with the props of onclose function */}
      <Modal show={showDelete} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Text variant='title-sm' color='main' bold>
              Confirmation
            </Text>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text bold variant='confirmation' color='danger' values='Permanently you want to delete this item form Subscription list' />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='transparent' onClick={handleClose}>
            <Icons icon="close" />
            Close
          </Button>
          <Button variant='transparent' onClick={() => _willDelete()}>
            <Icons icon="delete_forever" />
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

    </Main>
  )
}
export interface TablefooterProps {
  children?: React.ReactNode
}

// Table footer style.  
const TableFooter = (props: TablefooterProps) => {

  const tablefooter = classNames('tablefooter')

  return (
    <Flex jc='jc-between' className={tablefooter}>
      {props.children}
    </Flex>
  )

}

export interface TableActionsProps {
  children?: React.ReactNode
}

// Table body style.  
const TableActions = (props: TableActionsProps) => {

  const tableAction = classNames('tableAction')

  return (
    <Flex jc='jc-center' className={tableAction}>
      {props.children}
    </Flex>
  )

}

interface searchProps {
  children?: React.ReactNode
}

//Search Form Component  for displaying serarch box, and add ship button
const SearchForm = (props: searchProps) => {

  const search = classNames('serachForm')
  return (
    <form autoComplete='off' className={search}>
      {props.children}
    </form >
  )
}

// Declare the variable.  
const mapStateToProps = (state: any) => ({
  subscription: state.subscription.subscription,
  isLoading: state.subscription.isLoading,
  error: state.subscription.error,
  totalElement: state.subscription.totalElement,
  totalPage: state.subscription.totalPage
})

// Connect to the action and get the list, totalpage and total elements.  
export default connect(
  mapStateToProps,
  {
    subscriptionListGetAction,
    subscriptionSetSelectedAction,
  }

)(SubscriptionList)